// js/Component/AddressBook/SegmentedToggle.jsx
import React from "react";

function SegmentedToggle({ options, value, onChange }) {
    return (
        <div
            role="radiogroup"
            style={{
                display: "inline-flex",
                border: "1px solid #ccc",
                borderRadius: 6,
                overflow: "hidden",
                backgroundColor: "#fff",
            }}
        >
            {options.map((opt) => {
                const active = opt.value === value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        role="radio"
                        aria-checked={active}
                        onClick={() => onChange(opt.value)}
                        style={{
                            padding: "6px 14px",
                            fontSize: 13,
                            border: "none",
                            cursor: "pointer",
                            backgroundColor: active ? "#007bff" : "transparent",
                            color: active ? "#fff" : "#333",
                            fontWeight: active ? 600 : 400,
                        }}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}

export default SegmentedToggle;
